import React from 'react';

import Seo, { type SeoProps } from 'components/SEO';
import { IS_DE_LANG_ENV } from 'config/env';

import defaultImage from '../../../../../static/social-previews/blog/blog_cover_default.png';

export interface BlogSeoProps extends SeoProps {
    keywords?: string;
}

export const BlogSeo = ({
    image = defaultImage,
    titleTemplate = IS_DE_LANG_ENV ? '%s | Ackee Blog' : '%s | Ackee blog',
    keywords,
    meta = [],
    ...rest
}: BlogSeoProps) => {
    const blogSeoMeta = keywords ? meta.concat([{ name: 'keywords', content: keywords }]) : meta;

    return <Seo {...rest} image={image} titleTemplate={titleTemplate} meta={blogSeoMeta} />;
};
